module.exports = __webpack_public_path__ + "static/media/professional-catering.efa27b3d.jpg";